(() => {
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const disclosure = event.target.closest('.pk-nav details[open]');
    if (disclosure) {
      event.preventDefault();
      event.stopImmediatePropagation();
      disclosure.open = false;
      disclosure.querySelector('summary').focus();
    } else if (document.body.classList.contains('menu_open')) {
      document.querySelector('#navigation-mobile [data-menu-close-sidebar]')?.click();
      document.querySelector('.mobileMenu-toggle')?.focus();
    }
  }, true);
  document.addEventListener('click', event => {
    document.querySelectorAll('.pk-shop[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('.pk-shop[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  const panel = document.getElementById('navigation-mobile');
  if (!panel) return;
  let wasOpen = false;
  let opener;
  const sync = () => {
    const open = document.body.classList.contains('menu_open');
    panel.inert = !open;
    panel.setAttribute('aria-hidden', String(!open));
    document.querySelectorAll('.mobileMenu-toggle').forEach(button => {
      button.setAttribute('aria-controls', 'navigation-mobile');
      button.setAttribute('aria-expanded', String(open));
    });
    if (open && !wasOpen) {
      opener = document.activeElement;
      panel.querySelector('[data-menu-close-sidebar]')?.focus();
    }
    if (!open && wasOpen && panel.contains(document.activeElement)) opener?.focus();
    wasOpen = open;
  };
  new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  panel.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const items = Array.from(panel.querySelectorAll('a[href],button,summary,input')).filter(el => el.getClientRects().length && !el.disabled);
    const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  sync();
})();
document.querySelectorAll('.pk-nav-desktop .pk-category').forEach(menu => {
  menu.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') menu.open = true; });
  menu.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse' && !menu.contains(document.activeElement)) menu.open = false; });
  menu.addEventListener('focusout', event => { if (!menu.contains(event.relatedTarget)) menu.open = false; });
});
document.addEventListener('click', event => {
  document.querySelectorAll('.pk-nav-desktop .pk-category[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
});
